'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStashedVersion = getStashedVersion;
exports.setStashedVersion = setStashedVersion;

var _featureSupport = require('../constants/featureSupport');

var _getDependencyKey = function _getDependencyKey(dependencyName) {
  return 'HS_DEP_BUILD_NUMBER_' + dependencyName;
};

function getStashedVersion(dependencyName) {
  var stashedVersion = -1;

  if (_featureSupport.HAS_LOCAL_STORAGE_SUPPORT) {
    try {
      stashedVersion = localStorage[_getDependencyKey(dependencyName)];
    } catch (err) {
      /* DO NOTHING */
    }
  }

  return stashedVersion;
}

function setStashedVersion(dependencyName, version) {
  if (_featureSupport.HAS_LOCAL_STORAGE_SUPPORT) {
    try {
      localStorage[_getDependencyKey(dependencyName)] = version;
    } catch (err) {
      /* DO NOTHING */
    }
  }
}